import React from "react";
import hasContainer from "@root/helpers/has-container";
import CTA from "@_components/cta";
import RichText from "@root/components/rich-text";

const BreadcrumbsModule = ({ data }) => {
    if (!data) return null;
    return (
        <div className={`${hasContainer(data?.moduleSettings?.hasContainer) !== "container" ? "p-0" : "container"}`}>
            <CTA image={data?.image}>
                <RichText data={data?.content} />    
            </CTA>
        </div>
    );
};

export default BreadcrumbsModule;
